import React from 'react';
import Layer from '@atlaskit/layer';
import { layers } from '@atlaskit/theme';

/**
 * This component renders layered content with fixed positioning.
 * Scroll is locked outside the layer to prevent the layered content from detaching from the
 * container ref.
 *
 * TODO: Fix a bug in layer/popper.js where auto flip isn't occuring when it should because of vertical scroll distance incorrectly
 * making the library think the component is further up the page than it is.
 */
var FixedLayer = function FixedLayer(_ref) {
  var containerRef = _ref.containerRef,
      content = _ref.content;

  if (!containerRef) {
    // Wait for containerRef callback to cause a re-render
    return React.createElement('div', null);
  }
  var containerRect = containerRef.getBoundingClientRect();
  return (
    /* Need to wrap layer in a fixed position div so that it will render its content as fixed
     * We need to set the intial top value to where the container is and zIndex so that it still
     * applies since we're creating a new stacking context. */
    React.createElement(
      'div',
      {
        style: {
          position: 'fixed',
          top: containerRect.top,
          zIndex: layers.dialog()
        }
      },
      React.createElement(
        Layer,
        { shouldFlip: true, position: 'bottom left', content: content, lockScroll: true },
        React.createElement('div', {
          'data-layer-child': true,
          style: {
            height: containerRect.height,
            width: containerRect.width,
            background: 'transparent'
          }
        })
      )
    )
  );
};

export default FixedLayer;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/datetime-picker/dist/esm/internal/FixedLayer.js
// module id = 234
// module chunks = 0